import PropTypes from 'prop-types';
// import Thumbnail from '~/components/Thumbnail/Thumbnail';
// thumb: PropTypes.exact(Thumbnail.propTypes),
import Features from './Features';
import css from './Features.scss';

const classes = {
	root: css.features,
	header: css.featuresHeader,
	headerText: css.featuresHeaderText,
	thumb: css.featuresThumb,
	thumbList: css.featuresThumbList,
	thumbItem: css.featuresThumbItem,
	thumbLink: css.featuresThumbLink,
	thumbImage: css.featuresThumbImage,
	thumbControl: css.featuresThumbControl,
	thumbControlNext: css.featuresThumbControlNext,
	thumbControlPrev: css.featuresThumbControlPrev,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	mobile: PropTypes.bool,
	text: PropTypes.string,
	// list: PropTypes.arrayOf(PropTypes.shape({
	// 	id: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
	// 	path: PropTypes.string,
	// 	title: PropTypes.string,
	// 	modal: PropTypes.arrayOf(PropTypes.shape({
	// 		caption: PropTypes.string,
	// 		description: PropTypes.string,
	// 		poster: PropTypes.shape({
	// 			alt: PropTypes.string,
	// 			sources: PropTypes.arrayOf(PropTypes.shape({
	// 				media: PropTypes.string,
	// 				srcSet: PropTypes.string,
	// 			})),
	// 		}),
	// 		tabName: PropTypes.string,
	// 		title: PropTypes.string,
	// 	})),
	// 	thumb: PropTypes.shape({
	// 		alt: PropTypes.string,
	// 		src: PropTypes.string,
	// 		srcSet: PropTypes.arrayOf(PropTypes.string),
	// 	}),
	// })),
};

const defaultProps = {
	className: '',
	classes,
	mobile: false,
	text: '',
	list: [],
};

Features.propTypes = propTypes;
Features.defaultProps = defaultProps;
Features.displayName = 'Features';
export { Features };
export default Features;
